import checkAccess from 'utils/roles/checkAccess';
import {
  getChallengeAdminNavBar,
  getFacilityGymAdminNavBar,
  getFacilityStudioAdminNavBar,
  getFranchiseRegionAdmin,
  getSuperAdminNavBar,
  getVendorAdminNavBar,
  getYfcAdminNavBar,
} from './utils';

const sidebarConfig = ({ facilityType }) => {
  if (checkAccess([1])) {
    return getYfcAdminNavBar();
  }

  if (checkAccess([2])) {
    return getFranchiseRegionAdmin();
  }

  if (checkAccess([0])) {
    return getSuperAdminNavBar();
  }

  if (checkAccess([4])) {
    return getVendorAdminNavBar();
  }

  if (checkAccess([5])) {
    return getChallengeAdminNavBar();
  }

  if (checkAccess([3])) {
    if (facilityType === 'Gym') {
      return getFacilityGymAdminNavBar();
    }

    if (facilityType === 'Studio') {
      return getFacilityStudioAdminNavBar();
    }

    return [];
  }

  return [];
};

export default sidebarConfig;
